<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/inbound_outbound_reports" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaobianma/mingcheng')">
            <yi_cross_select multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId"> </yi_cross_select>
            <!--            <yi_data_select :multiple="true":selectTitle="'code,name'" :type="'material2'" :ids.sync="yt.conditions.materialId">-->
            <!--            </yi_data_select>-->
          </el-form-item>
          <el-form-item :label="$t('riqi')">
            <yi_time_input type="daterange" :format="'yyyy-MM-dd'" :start.sync="yt.conditions.startDateStart" :end.sync="yt.conditions.endDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'" :ids.sync="yt.conditions.supplierId"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, null, afterReq)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  {
                    startDateStart: dayjs()
                      .startOf('month')
                      .valueOf(),
                    endDateEnd: dayjs()
                      .endOf('month')
                      .valueOf(),
                  },
                  null,
                  afterReq
                )
              "
            >
              {{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #footer>
        <!-- 这里可以在底部填写东西 -->
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div style="font-size: 17px;font-weight: bold">
            {{ $t("heji") }}
          </div>
          <div style="margin-left: 8px;color: #606266;font-size: 14px">
            <span style="font-size: 14px;font-weight: bold">{{ $t("qichukucun") }}:</span>
            <span style="margin-left: 8px">{{ openingInventorySum == NaN || openingInventorySum == null || openingInventorySum == undefined ? 0 : openingInventorySum }}</span>
          </div>
          <div style="margin-left: 8px;color: #606266;font-size: 14px">
            <span style="font-size: 14px;font-weight: bold">{{ $t("rukushuliang") }}:</span>
            <span style="margin-left: 8px">{{ warehousingSum == NaN || warehousingSum == null || warehousingSum == undefined ? 0 : warehousingSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("chukushuliang") }}:</span>
            <span style="margin-left: 8px">{{ outboundSum == NaN || outboundSum == null || outboundSum == undefined ? 0 : outboundSum }}</span>
          </div>
          <div style="margin-left: 12px;color: #606266;font-size: 14px">
            <span style="font-weight: bold">{{ $t("qimokucunshu") }}:</span>
            <span style="margin-left: 8px">{{ endingInventorySum == NaN || endingInventorySum == null || endingInventorySum == undefined ? 0 : endingInventorySum }}</span>
          </div>
        </div>
      </template>
      <template #qimokucunshu="scope">
        <!-- 期末库存数 = 期初库存+入库数量-出库数量 -->
        {{ scope.row.openingInventory + scope.row.warehousing - scope.row.outbound }}
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_report_material_summary_table",

  data() {
    return {
      exportLoading: false,
      openingInventorySum: 0,
      warehousingSum: 0,
      outboundSum: 0,
      endingInventorySum: 0,
      list: [],
      totalExtend: {},
      columns: [
        {
          label: "wuliaobianma",
          prop: "materialCode",
          width: 130,
        },
        {
          label: "wuliaomingcheng",
          prop: "materialName",
          width: 130,
        },
        {
          label: "chanpinfenlei",
          prop: "materialValue",
          type: "dictionary",
          key: "GYLXCPFL",
          // width: 130,
        },
        {
          label: "gongyingshangmingcheng",
          prop: "supplierName",
          width: 130,
        },
        {
          label: "danwei",
          prop: "unit",
          type: "dictionary",
          key: "UNIT_CONVERSION_TYPE",
          width: 130,
        },
        {
          label: "qichukucun",
          prop: "openingInventory",
          width: 130,
        },
        {
          label: "rukushuliang",
          prop: "warehousing",
          width: 130,
        },
        {
          label: "chukushuliang",
          prop: "outbound",
          width: 130,
        },
        {
          label: "qimokucunshu",
          type: "slot",
          width: 130,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.startDateStart = this.dayjs()
        .startOf("month")
        .valueOf();
      this.yt.conditions.endDateEnd = this.dayjs()
        .endOf("month")
        .valueOf();
      this.yt.get(1, null, this.afterReq);
    }, 300);
  },
  methods: {
    afterReq(results) {
      this.totalExtend = results.data.extend;
      this.openingInventorySum = 0;
      this.warehousingSum = 0;
      this.outboundSum = 0;
      this.endingInventorySum = 0;
      for (let i = 0; i < results.data.rows.length; i++) {
        this.openingInventorySum += results.data.rows[i].openingInventory;
        this.warehousingSum += results.data.rows[i].warehousing;
        this.outboundSum += results.data.rows[i].outbound;
        this.endingInventorySum += results.data.rows[i].openingInventory + results.data.rows[i].warehousing - results.data.rows[i].outbound;
      }
      return results;
    },

    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/inbound_outbound_reports", {
          params,
        })
        .then((res) => {
          this.exportLoading = false;
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    },
    // 重置
    // clear() {
    // 	this.yt.conditions = {
    // 		createTimeStart: this.begin(),
    // 		createTimeEnd: this.end()
    //
    // 	}
    // 	this.yt.list = []
    // },
  },
};
</script>
